import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// custom formatters
export var formatValueProps = function formatValueProps(content) {
  if (!content) {
    return;
  }
  var line1 = content.line1,
    line2 = content.line2,
    itemListCollection = content.itemListCollection,
    productFamily = content.productFamily;
  return _objectSpread(_objectSpread({
    line1: line1,
    line2: line2
  }, productFamily && {
    productFamily: productFamily
  }), {}, {
    items: itemListCollection.items.map(function (item) {
      return item.line1;
    })
  });
};

// Pull the number from the string since the price can have curreny codes
// and symbols and different formats (eg: "AUD $15.50", "₺706,94")
// This is temporary until we include just the price for
// pricePlans returned from the V2 pricing call
export var getDisplayPrice = function getDisplayPrice(price) {
  if (!price) {
    return undefined;
  }
  var priceWithoutLastComma = price.replace(/\,(\d\d)$/, '.$1');
  return priceWithoutLastComma.replace(/[^0-9.-]+/g, '');
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/ContentFormatterUtil.js
// module id = 3496
// module chunks = 11